import React, { useEffect, useState } from 'react';
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const filterSelectStyle = {
    backgroundColor: "#b15cd6",
    color: "#fff",
    border: "none",
    height: "35px",
    borderRadius: "4px"
};

const filterButtonStyle = {
    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    height: '35px',
    borderRadius: "4px",
    padding: '0 15px'
};

const Fooddataoverview = () => {
    const [activeTab, setActiveTab] = useState('Overview');
    const [data, setData] = useState([]);
    const [searchDate, setSearchDate] = useState(''); // Single date picker
    const [filteredData, setFilteredData] = useState([]);
    const { showLoader, hideLoader } = useLoader();
    // Fetch orders
    useEffect(() => {
        const controller = new AbortController();
        const fetchOrders = async () => {
            try {
                showLoader();
                const token = localStorage.getItem("authToken");
                const headers = token ? { Authorization: `Bearer ${token}` } : {};
                const res = await fetch(
                    "https://backend.maamaas.com/food/api/orders",
                    { headers, signal: controller.signal }
                );
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                const fetchedApiData = await res.json();
                setData(Array.isArray(fetchedApiData) ? fetchedApiData : []);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Fetching error:", err);
                    setData([]);
                }
            } finally {
                hideLoader();
            }
        };
        fetchOrders();
        return () => controller.abort();
    }, []);

    // Filter data based on date picker
    useEffect(() => {
        let filtered = [...data];

        if (searchDate) {
            filtered = filtered.filter(item => {
                const itemDate = new Date(item.orderDateAndTime).toISOString().split('T')[0];
                return itemDate === searchDate;
            });
        }

        setFilteredData(filtered);
    }, [searchDate, data]);

    // CSV Export
    const handleExport = () => {
        if (filteredData.length === 0) {
            alert("No data to export based on the current filter.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = ["S.NO", "Order ID", "Date", "Time", "Category", "Type", "Name", "Payment", "Status", "Amount", "Feedback", "Ratings"];
        const csvRows = filteredData.map((item, index) => [
            index + 1,
            item.orderId || 'N/A',
            item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleDateString() : 'N/A',
            item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'N/A',
            item.category || 'N/A',
            item.service || 'N/A',
            item.userName || 'N/A',
            item.paymentMethod || 'N/A',
            item.status || 'N/A',
            item.grandTotal !== undefined ? Math.round(item.grandTotal) : 'N/A',
            item.feedback || 'N/A',
            item.ratings || 'N/A'
        ]);

        const csvString = [headers.map(escapeCsvField).join(','), ...csvRows.map(row => row.map(escapeCsvField).join(','))].join('\r\n');
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "orders.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const tabContent = {
        Overview: (
            <div>
                <div className="d-flex flex-wrap align-items-center mb-1 pt-3 rounded ps-0" style={{ gap: "10px" }}>
                    {/* Date Picker */}
                    <div style={{ flex: "0 0 auto" }}>
                        <input
                            type="date"
                            value={searchDate}
                            onChange={(e) => setSearchDate(e.target.value)}
                            className="form-control form-control-sm"
                            style={filterSelectStyle}
                        />
                    </div>

                    {/* Export button */}
                    <div className='pe-2' style={{ marginLeft: "auto" }}>
                        <button
                            type="button"
                            className="btn btn-sm fw-bold"
                            style={filterButtonStyle}
                            onClick={handleExport}
                        >
                            Export
                        </button>
                    </div>
                </div>

                <div className="table-responsive rr pe-2">
                    <table className="table-striped table-bordered align-middle" style={{ fontSize: "0.95rem", width: "100%" }}>
                        <thead>
                            <tr>
                                <th style={tableHeaderStyle}>OrderID</th>
                                <th style={tableHeaderStyle}>VendorID</th>
                                <th style={tableHeaderStyle}>Location</th>
                                <th style={tableHeaderStyle}>Date</th>
                                <th style={tableHeaderStyle}>Time</th>
                                <th style={tableHeaderStyle}>Category</th>
                                <th style={tableHeaderStyle}>Type</th>
                                <th style={tableHeaderStyle}>Name</th>
                                <th style={tableHeaderStyle}>Payment</th>
                                <th style={tableHeaderStyle}>Status</th>
                                <th style={tableHeaderStyle}>Amount</th>
                                <th style={tableHeaderStyle}>Feedback</th>
                                <th style={tableHeaderStyle}>Ratings</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length ? (
                                filteredData.map((item, index) => (
                                    <tr key={item.orderId || index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}>
                                        <td style={tableCellStyle}>{item.orderId || "-"}</td>
                                        <td style={tableCellStyle}>#{item.vendorId || "-"}</td>
                                        <td style={tableCellStyle}>#{item.location || "-"}</td>
                                        <td style={tableCellStyle}>{item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleDateString() : "N/A"}</td>
                                        <td style={tableCellStyle}>{item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "-"}</td>
                                        <td style={tableCellStyle}>{item.appType || "-"}</td>
                                        <td style={tableCellStyle}>{item.orderService || "-"}</td>
                                        <td style={tableCellStyle}>{item.userName || "-"}</td>
                                        <td style={tableCellStyle}>{item.paymentMethod || "-"}</td>
                                        <td style={tableCellStyle}>{item.paymentStatus || "-"}</td>
                                        <td style={tableCellStyle}>₹{item.grandTotal !== undefined ? Math.round(item.grandTotal) : "-"}</td>
                                        <td style={tableCellStyle}>{item.feedback || "-"}</td>
                                        <td style={tableCellStyle}>
                                            {[1, 2, 3, 4, 5].map((star) => (
                                                <span key={star} style={{ color: item.ratings && Number(item.ratings) >= star ? "#FFD700" : "#e4e5e9", fontSize: 18, marginRight: 2 }}>★</span>
                                            ))}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="13" style={{ ...tableCellStyle, fontStyle: "italic" }}>No data matches your filter.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    };

    return (
        <div>
            <div className="row" style={{ marginTop: '10px' }}>
                <div className="col-12">
                    <div style={{ overflowY: 'auto', height: 'calc(85vh - 40px)', marginTop: '-60px', scrollbarWidth: 'none' }}>
                        <div style={{ marginTop: '20px', borderRadius: '8px' }}>
                            {tabContent[activeTab]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
    padding: 6,
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: 6,
};

export default Fooddataoverview;
